import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const MessageArchivingSettings = lazy(() =>
  import("@scenes/MessageArchivingSettings").then((module) => ({
    default: module.default.MessageArchivingSettings,
  }))
);

export const messageArchivingNRO: NavigationRoutingObject = {
  Component: MessageArchivingSettings,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("message-archiving-settings-pill-menu-option", "Message Archiving"),
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("message_archiving");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
